import { render, staticRenderFns } from "./TopSection.vue?vue&type=template&id=631835fc&scoped=true"
import script from "./TopSection.vue?vue&type=script&lang=js"
export * from "./TopSection.vue?vue&type=script&lang=js"
import style0 from "./TopSection.vue?vue&type=style&index=0&id=631835fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "631835fc",
  null
  
)

export default component.exports